<template>
    <v-app>
        <side-menu v-if="user" />
        <v-main class="bg-gradient-to-br from-primary-pink via-secondary-purple to-primary-blue">
            <div class="pa-6 fill-height">
                <!-- Banner de expiração Pro -->
                <pro-expiration-banner v-if="user" />
                
                <the-notify />
                <router-view />
            </div>
        </v-main>
        <the-float-button v-if="user" />
        <the-news-modal v-if="user" />
        <!-- Modal global de upgrade -->
        <upgrade-modal />
        <!-- Overlay de trial expirado -->
        <trial-expired-overlay v-if="user" />
    </v-app>
</template>

<script>
import SideMenu from './components/SideMenu.vue';
import TheNotify from './components/TheNotify.vue';
import TheFloatButton from './components/TheFloatButton.vue';
import TheNewsModal from './components/TheNewsModal.vue';
import TrialExpiredOverlay from './components/TrialExpiredOverlay.vue';
import { mapState } from 'vuex';

export default {
    components: {
        SideMenu,
        TheNotify,
        TheFloatButton,
        TheNewsModal,
        TrialExpiredOverlay
    },
    computed: {
        ...mapState("auth", {
            user: state => state.user
        })
    }
};
</script>
